<template>
  <div @click="setMe" class="card" :class="{ selected: selected }">
    <img src="~@/assets/img/load-img.png" alt="disk image" style="width:100%" />
    <div class="container">
      <h4><b>דיסק אוצר החכמה</b></h4>
      <p>{{ disk.mountPoint }}</p>
      <p>דיסק חיצוני</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["disk", "selected"],
  methods: {
    setMe() {
      this.$emit("click", this.disk);
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 200px;
  cursor: pointer;
  margin: 10px;
}

.card:hover {
  box-shadow: 0 16px 24px 0 rgba(0, 0, 0, 0.2);
}
.selected {
  border: 1px solid grey;
}
.container {
  padding: 2px 16px;
}
</style>
